<template>
  <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
    <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
      <b-row>
        <b-col>
          <div class="card shadow-sm border card-body mb-0 d-flex h-100">
            <h2 class="pb-4">User Profile</h2>

            <base-input
              name="Name"
              mode="lazy"
              rules="required"
              label="Name"
              v-model="form.name"
            />

            <base-input
              name="E-Mail Address"
              mode="lazy"
              rules="required|email"
              label="Email Address"
              v-model="form.email"
            />

            <b-form-checkbox
              v-model="form.bccOnSystemEmail"
              name="check-button"
              class="mt-3"
            >
            </b-form-checkbox>
            <h4 class="pt-1">Email Notifications</h4>
            <p class="small text-gray mt--2 mb-5">
              User will be copied on all notifications and receipts.
            </p>

            <b-form-checkbox v-model="form.notifyUser" name="check-button"
              >Send Reset Password Notification
            </b-form-checkbox>

            <b-form-checkbox v-model="form.isActive" name="check-button"
              >Active
            </b-form-checkbox>
          </div>
        </b-col>
        <b-col>
          <div class="card shadow-sm border card-body mb-0">
            <h2 class="pb-4">Permissions</h2>
            <Role
              :availableRoles="availableRoles"
              :roles="form.roles"
              @rolesUpdated="rolesUpdated"
              class="pb-3"
            ></Role>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <b-button @click.prevent="cancel" variant="warning">Cancel</b-button>
          <b-button type="submit" variant="success">Save Profile</b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import Role from "@/views/Components/User/Role.vue";
export default {
  components: { Role },
  props: {
    user: null,
    timeZones: null,
    availableRoles: null,
  },

  data() {
    return {
      form: null,
    };
  },
  watch: {
    user: {
      handler(user) {
        this.form = JSON.parse(JSON.stringify(user));
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    rolesUpdated(role) {
      this.form.roles = role;
    },
    cancel() {
      this.$emit("cancel");
    },
    onSubmit() {
      var self = this;

      self.$emit("userUpdated", self.form);
    },
  },
};
</script>

<style>
.custom-checkbox .custom-control-input ~ .custom-control-label:after,
.custom-checkbox .custom-control-input ~ .custom-control-label:before {
  top: 0.1em;
}
</style>
